import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as fromBusinessActions from '../actions/gbp.actions';
import * as fromBusinessReducer from '../reducers/gbp.reducer';
import * as fromBusinessSelector from '../selectors/gbp.selector';

@Injectable()
export class GBPFacade {

    constructor(private store: Store<fromBusinessReducer.GBPState>) { }

    get isLoading$(): Observable<boolean> {
        return this.store.select(fromBusinessSelector.getIsLoading);
    }
    get succeeded$(): Observable<any> {
        return this.store.select(fromBusinessSelector.getSucceeded);
    }
    get hasError$(): Observable<boolean> {
        return this.store.select(fromBusinessSelector.getHasError).pipe(filter((x) => x));
    }
    get error$(): Observable<any> {
        return this.store
            .select(fromBusinessSelector.getErrorMessage);
    }
    get gbp$(): Observable<any[]> {
        return this.store.select(fromBusinessSelector.getGBPData).pipe(filter((x) => !!x));
    }

    loadGBPData() {
        this.store.dispatch(fromBusinessActions.loadGBPBegin());
    }

}
